import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";
import { useUserStore } from "~/stores/userstore";
import { useCompanyStore } from "~/stores/companystore";

export default defineNuxtRouteMiddleware((_unused_to, _unused_from) => {
  console.debug("userHasNoCompany middleware");
  const userStore = useUserStore();
  const companyStore = useCompanyStore();
  const router = useRouter();

  if (userStore.authUser?.companyId || companyStore.userHasCompany) {
    console.warn(`User already has a company.`);
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Company Registration`,
      body: `You already are already member of a company.`,
      appendToast: false,
      position: "top-center",
      variant: "warning",
      solid: true,
    } as ToastItem);
    return router.push(
      "/users/" +
        userStore.authUserUuid +
        "/company/" +
        userStore.authUser?.companyId +
        "/profile",
    );
  }
});
